export interface ContentHeaderProps {
    header: string;
    /** Optional guidance shown under the header. */
    helpText?: string;
}

/** Heading (and optional help text) at the top of StandardModal's content area. */
export const ContentHeader = ({ header, helpText }: ContentHeaderProps) => {
    return (
        <div className='standardModalContentHeader'>
            <h2 className='standardModalContentHeader-header'>{header}</h2>
            {helpText && <p className='standardModalContentHeader-helpText'>{helpText}</p>}
        </div>
    );
};
